import React from 'react';
import {
  Card, Button, Row, Col,
} from 'react-bootstrap';

import DownloadLink from './DownloadLink';
import { dateRenderer, floatRenderer } from '../../services/formatSvc';
import docIcon from '../../../img/icons/doc.svg';
import imgIcon from '../../../img/icons/icon-img.svg';
import pdfIcon from '../../../img/icons/pdf.svg';
import xlsIcon from '../../../img/icons/xls.svg';
import txtIcon from '../../../img/icons/txt.svg';
import fileIcon from '../../../img/icons/file.svg';

export default function FileCard({ file, onRemove, readOnly }) {
  const getType = (filename) => filename.substring(filename.lastIndexOf('.') + 1)?.toLowerCase();

  const getIcon = (type) => {
    switch (type) {
      case 'doc':
      case 'docx':
        return docIcon;
      case 'txt':
        return txtIcon;
      case 'xls':
      case 'xlsx':
        return xlsIcon;
      case 'pdf':
        return pdfIcon;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'svg':
      case 'gif':
        return imgIcon;
      default: return fileIcon;
    }
  };

  return (
    <Row>
      <Col md="auto">
        <img className="file-icon" src={getIcon(getType(file.name))} alt="" style={formatIcon} />
      </Col>
      <Col md="auto">
        <DownloadLink url={`/files/download/${file.fileId || file.id}`} filename={file.name} style={topLink}>
          {file.name}
        </DownloadLink>
        <div style={fileInfo}>
          <span style={padded}>{dateRenderer(file.createdOn)}</span>
          <span style={padded}>
            {floatRenderer(file.contentLength / 1024)}
            {' '}
            Кбайт
          </span>
        </div>
      </Col>
      <Col md="auto">
        {!readOnly && <Button onClick={() => onRemove(file.id)} variant="light" className="btn-close" size="sm" style={{ verticalAlign: 'center' }} />}
      </Col>
    </Row>
  );
}

const formatIcon = { height: 50 };
const topLink = { textAlign: 'left', padding: 0 };
const fileInfo = { color: '#72808e', letterSpacing: '-.2px', textDecoration: 'none !important' };
const padded = { paddingRight: '12px' };
